import { mutationOptions } from '@tanstack/react-query';
import { client } from '#queries/utils';
import { firstparty as kycVerification } from '#proto/index.qonto.kycb.api.kyc_verification';
import type { SendKycSmsRequest } from './types';

function sendVerificationSms() {
  return mutationOptions({
    mutationFn: async (data: SendKycSmsRequest) => {
      const requestBody = kycVerification.v3.ApiSendKycSmsRequestKyc.toJSON(data);

      const response = await client(`/v3/verification/kyc/${data.redoToken}/sms`, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify(requestBody),
      });

      return kycVerification.v3.ApiSendKycSmsResponseKyc.fromJSON(response);
    },
  });
}

export const kycMutations = {
  sendVerificationSms,
};
